import SEOHead from '@/components/base/SEOHead';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function Disclaimer() {
  return (
    <>
      <SEOHead
        title="Disclaimer – All Yono Games"
        description="Read the disclaimer for All Yono Games. Understand our relationship with listed games, affiliate disclosures, bonus terms, and limitations of the information provided."
        keywords="Disclaimer, Yono Games Disclaimer, Affiliate Disclosure, Bonus Disclaimer"
      />

      <Header />

      <main>
        <div className="px-4 py-6">
          <h1 className="text-xl font-heading font-bold text-foreground-900 mb-4">
            Disclaimer
          </h1>
          <p className="text-foreground-400 text-[11px] mb-5">Last updated: July 13, 2026</p>

          <div className="space-y-4 text-foreground-600 text-[13px] leading-relaxed">
            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">General Disclaimer</h2>
            <p>
              The information provided on All Yono Games is for general informational and educational purposes only. While we strive to keep the information accurate and up to date, we make no representations or warranties of any kind about the completeness, accuracy, reliability, suitability, or availability of the information, products, services, or related graphics contained on the website.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">No Official Affiliation</h2>
            <p>
              All Yono Games is an independent informational directory. We are not affiliated with, endorsed by, or officially connected to any of the game developers, publishers, or platforms listed on this website. All game names, logos, and trademarks are the property of their respective owners. We are not the official owner or operator of any listed games.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Affiliate Disclosure</h2>
            <p>
              Some links on this website may be promotional or affiliate links. This means we may receive compensation from referred activity, at no additional cost to you. External links are marked with appropriate rel attributes. We do not control the content or practices of linked external websites.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Bonus and Offer Disclosure</h2>
            <p>
              Bonus values, deposit requirements, withdrawal terms, and promotional offers mentioned on this website are for reference only and may change at any time without notice. We do not guarantee the availability, accuracy, or value of any bonus, promotion, or reward mentioned. Users should verify current offer terms and conditions directly with the respective gaming platform before registering, depositing, or participating in any promotion.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Download Disclaimer</h2>
            <p>
              We do not host any APK files or application binaries on our servers. All download links direct users to external sources. Users are responsible for verifying the authenticity and safety of any application before downloading and installing it on their devices. We recommend reviewing app permissions carefully before installation.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Legal Compliance</h2>
            <p>
              Online gaming laws vary by state and region in India. It is your responsibility to ensure that accessing and using any gaming application complies with local laws, regulations, and age requirements. Users are responsible for checking their own eligibility and the legality of gaming activities in their jurisdiction. This website is intended for users aged 18 and above.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Financial Disclaimer</h2>
            <p>
              Any bonuses, rewards, or financial information mentioned on this website are for reference only and may change without notice. Real-money gaming involves financial risk. We do not provide financial advice, nor do we guarantee earnings, winnings, or withdrawals from any gaming platform. Never play with borrowed money.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}